import css from 'styled-jsx/css';

export default css.global`* {
  font-family: "Open Sans", sans-serif;
}

.breadcrumb {
  margin-bottom: 0;
}

.breadcrumb a {
  color: #0c4596;
}

.sidebar-menu {
  padding-top: 33px;
}

.main-sidebar svg {
  width: 10%;
  margin-right: 10px;
}

.sidebar-collapse img {
  width: 100%;
  margin-right: 10px;
}

.logo-lg img {
  width: 60%;
  position: relative;
  padding-left: 20px;
}

.content {
  padding-top: 33px;
}
.mda-content {
  padding: 13px;
  
}

.sidebar-toggle {
  display: none;
}
.bar-toggle {
  display: none;
}

.label {
  padding: 5px 18px;
  font-size: 10px;
  border-radius: 0;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-center {
  align-items: center;
}

.box-header.with-border {
  border-bottom: 1px solid #f4f4f4;
}

/*start support*/

.support__help-head-text {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  font-family: Raleway;
}

.support__help-icon {
  height: 80px;
}

.support__help-icon img {
  width: 76px;
  height: 76px;
}

.support-button,
.support__help-head-text,
.support__help-text {
  height: 40px;
}

.support__help-head-text p,
.support__help-text p {
  margin: 0;
  color: #7f7f7f;
}

.support-box {
  font-size: 16px;
  padding: 10px 0px;
}

.support-box hr,
.support-box h3 {
  padding: 0;
  margin: 0;
}

.support-box .support-box-header {
  height: 50px;
}

.support-box .support-box-header,
.support-box .support-box-content {
  padding: 10px 20px;
}

.support-box .support-box-content table th,
.support-box .support-box-content table td {
  padding: 12px 10px 12px 0px;
  font-size: 0.9em;
}

.support-box .support-box-content table td {
  color: #7f7f7f;
}

.support-box .support-box-title {
  font-size: 1.2em;
  color: #7f7f7f;
  font-weight: 600;
}

.support-box-content .support-content__child-box {
  padding: 10px 0px;
}

.support-box-content .support-content__child-box h3,
.support-box-content .support-content__child-box p {
  font-size: 0.9em;
  margin: 10px 0px;
}

.support-box-content .support-content__child-box h3 {
  font-weight: 600;
}

.alert-modified {
  padding: 10px 25px;
  border: none;
  border-left: 2px solid rgb(0, 19, 86);
  margin: 20px 0px;
}

.alert-info-modified {
  background-color: rgba(173, 216, 230, 0.455);
}

.alert-title {
  font-weight: bold;
  font-size: 14px;
}

.alert-content {
  font-weight: 500;
  font-size: 13px;
  color: #424242;
}

.history-date {
  clear: both;
}

.history-date p {
  font-size: 12px;
  color: #757575;
  font-weight: 600px;
}

.ticket-history table tbody tr td {
  padding: 20px 10px !important;
}

.ticket-history table tbody tr th {
  padding: 10px 10px !important;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.badge-modified {
  font-size: 10px;
  padding: 3px 10px;
  font-weight: 600;
  border-radius: 2px;
  color: #ffffff;
}

.badge-danger-mod {
  background-color: #ce262f;
}

.badge-warning-mod {
  background-color: #e29a00;
}

.p-30 {
  padding: 30px;
}

.p-10 {
  padding: 10px;
}

.w-100 {
  width: 100%;
}

.w-10 {
  width: 10%;
}

.mx-2 {
  margin: 0px 2em !important;
}

.mr-2 {
  margin-right: 1.2em !important;
}

.ml-2 {
  margin-left: 2em !important;
}

/*end support*/

/*
 * Component: top- header
 * ------------------
 */

.logo {
  font-family: "Raleway", sans-serif !important;
  font-size: 26px !important;
}

.logo-lg,
.logo-mini {
  font-weight: 900;
  color: #21714b;
  text-align: left;
}

.logo-lg span,
.logo-mini span {
  font-weight: 400;
  color: #7f7f7f;
}

.user.dropdown span {
  font-weight: bold;
  font-size: 15px;
  color: #424242;
}

.navbar-nav > li > a:hover,
.navbar-nav > li > a:focus,
.navbar-nav > li > a.active,
.nav .open > a,
.nav .open > a:focus,
.nav .open > a:hover {
  background-color: transparent;
}

.navbar-nav > .user-menu > .dropdown-menu {
  width: 180px;
  border-radius: 10px !important;
  border: none;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
}

.navbar-nav > .user-menu > .dropdown-menu > .user-body {
  padding: 15px 0;
  border: none;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer {
  background-color: transparent;
  padding: 15px 20px;
  border-top: 1px solid;
}

.navbar-nav > .user-menu > .dropdown-menu > .user-footer a img {
  width: 17px;
}

/*
 * Component: sidemenu
 * ------------------
 */

.sidebar-menu > li.sidenav-item {
  margin-top: 1rem;
}

.sidebar-menu > li > a {
  color: #191363;
  display: flex;
  align-items: center;
}

.sidebar-menu > li.active > a,
.sidebar-menu > li:hover > a {
  font-weight: bold;
}

.sidebar-menu .sidebar-menu--link {
  padding: 0.5rem 3rem;
}

.sidebar-menu .sidebar-menu--link img {
  width: 20px;
  margin-right: 2rem;
}

/*
 * Component: content-header
 * ------------------
 */

.content-header-welcome {
  padding: 60px 25px 0 25px;
}

.content-header-welcome > h1 {
  font-weight: bold;
  font-size: 32px;
  line-height: 35px;
  color: #21714b;
}

.content-header > h1 > span {
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #c0272a;
}

.content-header {
  /* padding: 60px 25px 0 25px; */
  /* text-align: center; */
  display: flex;
  justify-content: space-between;
  /* align-items: flex-end; */
}

/*
 * Component: summary boxes
 * ------------------
 */

.info-box {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  padding: 25px 20px;
  justify-content: space-evenly;
  border-bottom: 4px solid;
  border-radius: 5px;
}

.info-box-content {
  padding: 0;
  margin: 0;
}

.info-box-img img {
  height: 75px;
}

.info-box-number {
  font-size: 24px;
}

/*
 * Component: charts
 * ------------------
 */

.merchantChart {
  height: 500px;
}

/*
 * Component: box container
 * ------------------
 */

.box-header {
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
  color: #191363;
  /* margin-bottom: 25px; */
}

.box-header .box-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 25px;
  color: #21714b;
}

/* .box {
  padding-bottom: 45px;
} */

.box-footer a {
  margin-left: 8px;
}

.spacer {
  margin-bottom: 20px;
}
.down-spacer {
  margin-bottom: 1rem;
}

/*
 * Component: footer
 * ------------------
 */

.main-footer {
  text-align: center;
}

.main-footer ul {
  display: flex;
  margin: 0 auto;
  justify-content: center;
}

.main-footer ul li {
  list-style: none;
  margin-left: 20px;
}

.main-footer ul li a {
  font-family: sans-serif;
  font-size: 14px;
  margin-right: 20px;
  color: #21714b;
  font-weight: 300;
}

/* .box-tools .input-group {
  width: 300px;
  border: 1px solid #eee;
} */

.box-tools .input-group .btn-default {
  border: 1px solid #eee !important;
}

.table .btn-group,
.table .btn-group .btn-group-vertical {
  display: inline !important;
}

/* nav tabs */

.nav-tabs-custom {
  margin-bottom: 20px;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.main-tab.nav-tabs-custom > .tab-content {
  background: transparent;
  padding: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.settings .main-tab.nav-tabs > li {
  width: 20%;
  text-align: center;
}

.settings .main-tab.nav-tabs > li > a {
  margin-right: 2px;
  line-height: 1.42857143;
  border: 1px solid transparent;
  border-radius: 0;
  border-right: 1px solid #ddd;
  color: #7f7f7f;
}

.settings .main-tab.nav-tabs {
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  background-color: #fff;
}

.settings .main-tab.nav-tabs > li.active > a,
.settings .main-tab.nav-tabs > li.active > a:focus,
.settings .main-tab.nav-tabs > li.active > a:hover {
  color: #555;
  cursor: default;
  background-color: #fff;
  border: none;
  border-bottom-color: #ddd;
  color: #21714b;
  font-weight: 700;
  border-right: 1px solid #ddd;
}

.settings .nav-tabs > li > a:hover {
  color: #21714b;
  font-weight: 600;
  background-color: #fff;
  border: none;
  border-bottom-color: #ddd;
  cursor: pointer;
  border-right: 1px solid #ddd;
}

.nav-tabs-custom > .nav-tabs > li {
  border-bottom: 3px solid transparent;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
  color: #555;
  cursor: default;
  background-color: #fff;
  border: none;
}

.tab-content.line-tab {
  padding: 30px;
}

/* merchant-dashboard rule*/

/* .merchant-dashboard {
  display: flex;
  flex-direction: column;
  align-items: center;
} */

.merchant-dashboard .products-container .product {
  background-color: #fff;
  box-shadow: 0px 0px 31px rgba(0, 0, 0, 0.11);
  border-radius: 26px;
  width: 46%;
  margin-bottom: 4%;
  height: 140px;
  margin-right: 4%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  justify-content: center;
}

.merchant-dashboard .products-container .product img {
  width: 80px;
  margin-right: 10px;
}

.merchant-dashboard .products-container .product span {
  color: #141656;
  font-weight: 600;
  font-size: 18px;
}

.merchant-dashboard .products-container {
  width: 70%;
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: center;
}

.merchant-dashboard .support-mast {
  background-color: #14153a;
  color: #fff;
  margin: 0 auto;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
}

.merchant-dashboard .support-mast h3 {
  margin: 0;
  margin-bottom: 12px;
  font-size: 2em;
}

.merchant-dashboard .support-mast img {
  width: 10%;
  margin-right: 9px;
}

.table-filter {
  padding: 25px;
}

.role-title {
  font-weight: 500;
  color: #c0272a;
  margin-top: 20px;
  margin-left: 15px;
}

.role-title .check {
  margin-bottom: 7px;
  font-weight: 600;
}

.checked-margin{
  margin-top: 12px;
}

.permission-container {
  padding: 30px;
}

.permission-container hr {
  margin-top: 0;
}

.permissions {
  padding-left: 15px;
  display: flex;
  flex-wrap: wrap;
}

.permissions .check {
  width: 24%;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.permission-type {
  padding-left: 30px;
}

.sub-permission-cont {
  margin-bottom: 10px;
}

.dropdown-menu > .active > a,
.dropdown-menu > .active > a:focus,
.dropdown-menu > .active > a:hover {
  color: #ffffff;
  background-color: #21714b;
  outline: 0;
}

.fas {
  color: #b0afaf;
}

.active-accordion {
  color: #af1824 !important;
  border: 1px solid #af1824 !important;
  background-color: #fff5f6 !important;
}

.red-icon {
  color: #af1824 !important;
}

.grey-text {
  color: #b0afaf;
}

.panel-default {
  border: none !important;
}

.file-upload {
  position: relative;
  display: inline-block;
}

.file-upload__label {
  display: block;
  border-radius: 0.4em;
  transition: background 0.3s;
  cursor: pointer;
  font-weight: 600;
  margin-right: 16px;
}

.btn-payCon-outline {
  background-color: transparent;
  border-color: #af1824;
  color: #af1824;
  padding: 7px 30px;
  /* border-radius: 0; */
}

input[type="file"] {
  display: block;
}

.file-upload__input {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 1;
  width: 0;
  height: 100%;
  opacity: 0;
}

.br-20 {
  border-radius: 20px;
}

.text-center {
  text-align: center;
}

h5#changePasswordLabel {
  font-size: 2em;
  font-weight: bold;
  color: #acacac;
}

.box-bill-row.box-bill__footer {
  padding-top: 20px;
}

.box-bill__footer--action {
  margin-top: 2rem;
}

.centeralized {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.with-min-height--500 {
  min-height: 500px;
}

.draft-invoice.centeralized img {
  width: 100px;
  height: auto;
}

.draft-invoice.centeralized p {
  color: grey;
  font-weight: bold;
  font-size: 2rem;
}

.invoice {
  border: 1px rgba(179, 179, 179, 0.18) solid;
  border-radius: 10px;
  padding: 1.5rem;
}

.invoice .invoice-header {
  display: flex;
  border-bottom: 2px solid #ce262f;
  padding: 1rem 0;
  margin-bottom: 1rem;
}
.invoice .invoice-header .logo {
  border: 1px dashed grey;
  padding: 0 1rem;
}

.invoice-header .invoice-header--title {
  margin-left: auto;
  text-align: right;
  color: #af1824;
}

.flex-row {
  display: flex;
  margin-bottom: 1rem;
}

.ml-auto {
  margin-left: auto;
}

.text-lightgrey {
  color: rgb(160, 160, 160);
}

.text-bold {
  font-weight: bold;
}

.text-dark {
  color: gray;
}

.invoice-head-bar {
  background: rgb(207, 207, 207);
  color: rgb(90, 90, 90);
  padding: 0.8rem 0.5rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.invoice-head-bar p {
  margin: 0;
}

.customer-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.customer-details .detail p:nth-child(2) {
  /* font-size: 1rem; */
  color: #5a5a5a;
  font-weight: bold;
  overflow-wrap: anywhere;
}

.product-details {
  margin-bottom: 1rem;
}

.product-details table {
  width: 100%;
  text-align: left;
}

.product-details table th {
  background-color: rgb(207, 207, 207);
  color: #5a5a5a;
  padding: 0.8rem 0.5rem;
}

.product-details table td {
  color: rgb(90, 90, 90);
  padding: 0.8rem 0.5rem;
}

.total-cont {
  text-align: right;
  font-size: 1rem;
  padding: 1rem 0;
  display: flex;
  justify-content: end;
}

.total-cont p {
  display: flex;
  justify-content: end;
  color: rgb(90, 90, 90);
  font-weight: bold;
}

.total-cont p span:nth-child(1) {
  margin-right: auto;
}

.total-cont--wrapper {
  width: 30%;
  min-height: 30px;
}

@media (max-width: 500px) {
  .total-cont--wrapper {
    width: 100%;
  }
}

@media (min-width: 501px) {
  .total-cont--wrapper {
    width: 50%;
  }
}

.border-top {
  border-top: 1px solid #b6b6b6;
}

.border-bottom {
  border-bottom: 1px solid #b6b6b6;
}

.text-right {
  text-align: right;
}

.invoice .send-cont {
  display: flex;
  justify-content: end;
  padding: 2rem 0;
}

/* .invoice-product {
} */

.invoice-product--form-cont {
  display: flex;
  justify-content: space-between;
}

.invoice-product--form-cont .product {
  width: 35%;
}
.invoice-product--form-cont .quantity {
  width: 20%;
}
.invoice-product--form-cont .price {
  width: 30%;
}

.invoice-product--form-cont .delete-btn-cont {
  width: 9%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  height: 98px;
  margin-bottom: -15px;
}

.invoice-product--form-cont .delete-btn-cont button {
  color: #21714b;
  width: 35px;
  height: 35px;
  background-color: #e6e6e6;
  border: none;
  font-weight: bold;
}

.discount-cont {
  padding: 3rem 0;
  margin-top: 4rem;
}

.remark {
  margin-bottom: 4rem;
}
.invoice-product {
  margin-top: 4rem;
}

.invoice-product--title {
  margin-bottom: 2rem;
}

.cursor-pointer {
  cursor: pointer;
}

.discount-radio-input--cont label {
  padding: 0 1rem;
  margin-bottom: 0;
}

.discount-radio-input--cont {
  display: flex;
  align-items: center;
}

.discount-radio-input--cont > div.form-group {
  width: 100%;
  margin-left: 2rem;
  margin-bottom: 0;
}

.sidebar-menu > li a.setup-account-link {
  background-color: #f7f4f4;
  border: 1px solid #af1824;
  border-radius: 6px;
  width: fit-content;
  padding: 1rem 2rem;
  color: #21714b;
  font-weight: bold;
}
.sidebar-menu > li.setup-account--menu-item {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #d8dcde;
}

.setup-account-link img {
  margin-right: 3rem;
}

.textarea.form-control {
  min-height: 150px;
}

.cicod-link {
  color: #43a8ff;
}

.cicod-link:hover {
  text-decoration: underline;
  color: #43a8ff;
}

.trial-expire-text {
  color: #424242;
}

@media (min-width: 768px) {
  .navbar-nav > li > a {
    padding-top: 30px;
    padding-bottom: 15px;
    cursor: pointer;
  }

  .box-bill__footer--action {
    margin-top: 0;
  }
}

@media only screen and (max-width: 767px) {
  .sidebar-toggle {
    display: block;
  }
  .bar-toggle {
    display: block;
    position: relative;
    top: 2rem;
    left: 1rem;
  }
  .sidebar-menu {
    padding-top: 57px;
  }
  .settings .main-tab.nav-tabs > li {
    width: auto;
    text-align: center;
  }
  ul.nav.nav-tabs.main-tab {
    margin-top: 4.9em;
    display: flex;
    flex-wrap: wrap;
  }

  .trial-expire-text {
    color: rgb(233, 233, 233) !important;
  }
}

@media (max-width: 768px) {
  .merchant-dashboard .products-container {
    flex-direction: column;
    width: 100%;
  }

  .merchant-dashboard .products-container .product {
    width: 100%;
  }

  .merchant-dashboard .support-mast {
    width: 100%;
  }
}
`